// extracted by mini-css-extract-plugin
module.exports = {"bgBlue":"tips-module--bgBlue--2U5wj","bgYellow":"tips-module--bgYellow--33lSa","container":"tips-module--container--bviMk","bordered":"tips-module--bordered--RR7xX"};